/* Dispatch line: "Order in 2h 14m 09s to get it by Thu 23 Oct" + "Ships from Brisbane today".
 * The deadline and the dispatch day come from ft-dispatch-deadline.js (window.FTDispatch), the
 * same module the cart drawer counts with. This file only writes the words, once a second, for
 * every [data-ftd] on the page. Loaded with defer; safe to include more than once. */
(function () {
  'use strict';
  if (window.__ftdLine) return;
  window.__ftdLine = true;

  var DAY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function arrival(from, n, biz) {
    if (biz) return window.FTDispatch.addBusinessDays(from, n);
    var t = new Date(from);
    t.setDate(t.getDate() + n);
    return t;
  }

  function tick() {
    var els = document.querySelectorAll('[data-ftd]');
    if (!els.length || !window.FTDispatch) return;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var c = window.FTDispatch.compute({ cutoffHour: el.getAttribute('data-ftd-cut'), tz: 'Australia/Brisbane' });
      var s = Math.floor(c.ms / 1000);
      var h = Math.floor(s / 3600);
      var time = (h ? h + 'h ' : '') + pad(Math.floor((s % 3600) / 60)) + 'm ' + pad(s % 60) + 's';
      var a = arrival(c.dispatch, parseInt(el.getAttribute('data-ftd-days'), 10) || 4, el.getAttribute('data-ftd-biz') === '1');
      var date = DAY[a.getDay()] + ' ' + a.getDate() + ' ' + MON[a.getMonth()];

      var l1 = el.querySelector('[data-ftd-l1]');
      if (l1) {
        l1.innerHTML = (el.getAttribute('data-ftd-text') || '')
          .replace('[time]', '<b>' + time + '</b>')
          .replace('[date]', '<b>' + date + '</b>');
      }
      var l2 = el.querySelector('[data-ftd-l2]');
      if (l2) {
        var key = c.phase === 'today' ? 'today' : (c.phase === 'tomorrow' ? 'tomorrow' : 'monday');
        var words = el.getAttribute('data-ftd-' + key);
        if (words && l2.textContent !== words) l2.textContent = words;
      }
    }
  }

  function start() {
    tick();
    setInterval(function () { if (!document.hidden) tick(); }, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
